import {
  NG_VALIDATORS,
  UntypedFormControl,
  ValidatorFn,
  Validator
} from '@angular/forms';
import { Directive } from '@angular/core';
@Directive({
  selector: '[appMultiEmailValidator]',
  standalone: false,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: MultiEmailValidatorDirective,
      multi: true
    }
  ]
})
export class MultiEmailValidatorDirective implements Validator {
  validator: ValidatorFn;
  constructor() {
    this.validator = this.multiemailValidator();
  }
  validate(c: UntypedFormControl) {
    return this.validator(c);
  }

  multiemailValidator(): ValidatorFn {
    let isValidFlag = false;

    return (c: UntypedFormControl) => {
      let errorMessage = '';

      const isValid = /(([a-zA-Z0-9\-?\.?]+)@(([a-zA-Z0-9\-_]+\.)+)([a-z]{2,3})(\W?[,;]\W?(?!$))?)+$/.test(
        c.value
      );

      if (
        typeof c.value === 'undefined' ||
        c.value === '' ||
        c.value === null
      ) {
        isValidFlag = true;
      } else
        if (!isValid) {
          errorMessage += 'Notified To Email is Invalid';
          isValidFlag = false;
        } else {
          isValidFlag = true;
        }
      return {
        multiemailValidator: {
          isValid: isValidFlag,
          error: errorMessage
        }
      };
    };
  }
}
